import { render, staticRenderFns } from "./users-table.vue?vue&type=template&id=21565987&"
import script from "./users-table.vue?vue&type=script&lang=js&"
export * from "./users-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports